/* eslint-disable no-restricted-globals */
import React from "react";
import { InputGroup } from "react-bootstrap";
import MaskedInput from "react-text-mask";
import moment from "moment";

function MobileDateField({ name, _value, error, setError, rawValue, setRawValue, setFieldValue, errorMessage, restrictDate, touched, errors }: any) {
  const isValidDate = (dateString: any) => {
    const date = new Date(dateString);
    const restricDateString: any = new Date(restrictDate);
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(date as unknown as number) && date.getTime() > restricDateString.getTime()) {
      setError(errorMessage);
    }
    return !Number.isNaN(date) && date.getTime() < restricDateString.getTime();
  };

  const handleCreatedDateFilter = (date: any) => {
    const noNextDate = date.isValid() && isValidDate(date.format("YYYY-MM-DD"));
    if (noNextDate) {
      setError("");
      setFieldValue(`${name}`, date.format("MM/DD/YYYY"));
    } else if (!noNextDate) {
      setFieldValue(`${name}`, "");
    }
  };

  const changeHandler = (e: any) => {
    const val = e.target.value;
    if (val) {
      setRawValue(val);
      handleCreatedDateFilter(moment(val));
    }
  };

  const blurHandler = () => {
    if (rawValue?.length > 0 && moment(rawValue).isValid()) {
      if (!isValidDate(rawValue)) {
        setError("User should always be above 13 years");
      } else {
        setError("");
      }
    } else if (rawValue?.length > 0) setError("Date should be in proper format mm/dd/yyyy");
    if (!rawValue?.length) setError("");
  };

  return (
    <div className="dateType">
      <div className="d-flex">
        <InputGroup className="flex-nowrap">
          <MaskedInput
            mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
            keepCharPositions
            guide
            onChange={changeHandler}
            onBlur={blurHandler}
            className="form-control w-100 bg-white"
            placeholder={"mm/dd/yyyy"}
            value={rawValue}
          />
          <InputGroup.Text className="bg-white border-start-0">
            {rawValue && (
              <i
                className="fa-regular fa fa-close mr-2 cursor-pointer text-danger"
                onClick={() => {
                  handleCreatedDateFilter(moment(null));
                  setRawValue("");
                }}
                aria-hidden="true"
              />
            )}
            <i className="fa-regular fa-calendar-days" aria-hidden="true" />
          </InputGroup.Text>
        </InputGroup>
      </div>
      {(error || (touched?.birthday && errors?.birthday)) && <p className="errorMsg text-danger">{error || errors?.birthday}</p>}
    </div>
  );
}

export default MobileDateField;
